import axios from 'axios'
import { Message, Loading } from 'element-ui'
import md5 from 'js-md5'

let loadingInstance
let loadingLength = 0
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 30000 // request timeout
})
service.defaults.headers.post['Content-Type'] = 'application/json'
service.interceptors.request.use(
  config => {
    loadingLength++
    if (loadingLength === 1) {
      loadingInstance = Loading.service({
        text: '正在加载'
      })
    }
    // do something before request is sent
    if (config.method === 'post') {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      const timestamp = new Date().getTime()
      const key = 'daylong@168.'
      const platform = 'web'
      const json = typeof config.data === 'object' ? JSON.stringify(config.data) : config.data
      config.headers['timestamp'] = timestamp
      config.headers['platform'] = platform
      config.headers['daylongPas'] = md5(timestamp + '+' + key + '+' + json + '+' + platform)
    }
    return config
  },
  error => {
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  async response => {
    loadingLength--
    if (loadingLength === 0) {
      if (loadingInstance) {
        loadingInstance.close()
      }
    }
    const res = response.data
    if (res.status === 1) {
      return res
    } else if (res.status === 1007 || res.status === 0 || res.status === 1021) {
      loadingInstance.close()
      if (loadingLength === 1) {
        Message({
          message: `登录过期，请从新登录`,
          type: 'error',
          duration: 5 * 1000
        })
      }
      
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      
      return Promise.reject(res)
    } else {
      Message({
        message: res.errorMsg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      if (loadingInstance) {
        loadingInstance.close()
      }
      return Promise.reject(res)
    }
  },
  async error => {
    // loadingInstance.close()
    switch (error.response.status) {
      case 1020:
        loadingInstance.close()
        if (loadingLength === 1) {
          Message({
            message: `登录过期，请从新登录`,
            type: 'error',
            duration: 5 * 1000
          })
        }

        await new Promise(res => setTimeout(res, 1000))
        // this.$router.push(`/login?redirect=${this.$route.fullPath}`)

        break
    }
    return Promise.reject(error)
  }
)

export default service
